export default "__VITE_ASSET__YScqn2kt__"